import * as React from 'react';
import { CoreDropdown } from '../internal/WixUiCoreComponents/components/CoreDropdown';
import { DropdownOption } from '../Dropdown/DropdownOption';
import { TPAComponentsConsumer } from '../../../../esm/components/TPAComponentsConfig';
import { st, classes } from './FloatingDropdown.st.css';
import { FloatingDropdownBase } from './FloatingDropdownBase';
import { DATA_HOOKS } from './constants';
import { OptionFactory, } from '../internal/WixUiCoreComponents/components/CoreDropdownOption';
import { modifyOptions } from '../Dropdown/helpers';
import uniqueId from '../../common/uniqueId';
/* TODO
 * The import below is a workaround. FloatingDropdown and Dropdown
 * components should be refactored according to this thread
 * https://github.com/wix/wix-ui-tpa/pull/387 (or merged into a single component)
 */
import { classes as dropdownClasses } from '../Dropdown/Dropdown.st.css';
import classnames from 'classnames';
import { deprecationLog } from '../../common/deprecationLog';
/** Dropdown component for sort. */
export class FloatingDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: false,
            ariaActivedescendant: null,
        };
        this._onSelect = (selectedOption) => {
            if (!selectedOption) {
                return;
            }
            this.setState({
                ariaActivedescendant: null,
            });
            if (this.props.onChange) {
                this.props.onChange(selectedOption);
            }
        };
        this._onCoreSelect = (selectedCoreOption) => {
            if (!selectedCoreOption) {
                return;
            }
            const selectedOption = this.props.options.find(({ id }) => selectedCoreOption.id === id);
            this._onSelect(selectedOption);
        };
        this._onExpandedChange = (isExpanded) => {
            const { onExpandedChange } = this.props;
            this.setState(Object.assign({ isExpanded: !this.state.isExpanded }, (!isExpanded && { ariaActivedescendant: null })), () => onExpandedChange && onExpandedChange(isExpanded));
        };
        this._onOptionHover = (option) => {
            const ariaActivedescendant = option ? option._DOMid : null;
            this.setState({ ariaActivedescendant });
        };
        this.contentId = uniqueId('floating-dropdown-options-container_');
    }
    componentDidMount() {
        if (!this.props.removeElementMinWidth) {
            deprecationLog('FloatingDropdown', 'The current `FloatingDropdown` component API will be deprecated in a future version. Please use the `removeElementMinWidth` prop in order to use the new API.');
        }
    }
    _generateCoreOptions() {
        const { options } = this.props;
        const coreOptions = options.map((option) => option.divider
            ? OptionFactory.createDivider({ className: classes.optionDivider })
            : OptionFactory.create(Object.assign(Object.assign({}, option), { 
                // Should internally add the `isSelectable` property to the item (needed by the wix-ui-core dropdown in order to trigger the onClick event)
                isSelectable: option.unavailable && option.isSelectable === undefined
                    ? true
                    : option.isSelectable, render: () => (React.createElement(DropdownOption, Object.assign({ className: classes.option }, option))) })));
        return {
            coreOptions,
        };
    }
    _getContent(mobile) {
        const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, disabled, forceContentElementVisibility, label, placeholder, value, options, name, id, placement, appendTo, displayBlock, dynamicWidth, removeElementMinWidth, } = this.props;
        const { coreOptions } = this._generateCoreOptions();
        const defaultPlacement = removeElementMinWidth ? 'bottom-start' : 'bottom';
        const popoverPlacement = placement ? placement : defaultPlacement;
        const baseElement = (React.createElement(FloatingDropdownBase, { className: classes.floatingDropdownBase, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, disabled: disabled, label: label, placeholder: placeholder, value: value, name: name, mobile: mobile, options: modifyOptions(options), id: id, "aria-activedescendant": this.state.ariaActivedescendant, isExpanded: this.state.isExpanded, onChange: this._onSelect, displayBlock: displayBlock }));
        return mobile ? (baseElement) : (React.createElement(CoreDropdown, { className: classes.dropdown, contentClassName: dropdownClasses.dropdownContainer, "data-hook": DATA_HOOKS.coreDropdown, "data-mobile": mobile, forceContentElementVisibility: forceContentElementVisibility, initialSelectedIds: value ? [value] : [], onInitialSelectedOptionsSet: () => { }, onDeselect: this._onCoreSelect, onSelect: this._onCoreSelect, openTrigger: "click", disabled: disabled, options: coreOptions, placement: popoverPlacement, onExpandedChange: this._onExpandedChange, appendTo: appendTo, onOptionHover: this._onOptionHover, dynamicWidth: dynamicWidth || appendTo === 'window', contentId: this.contentId, dropdownA11yFixes: true }, baseElement));
    }
    render() {
        const { removeElementMinWidth } = this.props;
        return (React.createElement(TPAComponentsConsumer, null, ({ mobile }) => (React.createElement("div", { "data-mobile": mobile, "data-hook": this.props['data-hook'], className: st(classes.root, { mobile, removeElementMinWidth }, classnames(classes.overrideStyleParams, this.props.className, {
                [classes.displayInline]: !this.props.displayBlock,
            })) }, this._getContent(mobile)))));
    }
}
FloatingDropdown.displayName = 'FloatingDropdown';
FloatingDropdown.defaultProps = {
    disabled: false,
    options: [],
    displayBlock: false,
};
//# sourceMappingURL=FloatingDropdown.js.map